var map = {
	"./de.svg": "./src/assets/paywall/ny2022-promo/de.svg",
	"./en.svg": "./src/assets/paywall/ny2022-promo/en.svg",
	"./es.svg": "./src/assets/paywall/ny2022-promo/es.svg",
	"./fr.svg": "./src/assets/paywall/ny2022-promo/fr.svg",
	"./it.svg": "./src/assets/paywall/ny2022-promo/it.svg",
	"./pt.svg": "./src/assets/paywall/ny2022-promo/pt.svg",
	"./ru.svg": "./src/assets/paywall/ny2022-promo/ru.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/paywall/ny2022-promo sync recursive ^\\.\\/.*\\.svg$";